import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ProfissionalListarComponent } from './profissional-listar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: ProfissionalListarComponent }
    ])],
    exports: [RouterModule]
})
export class ProfissionalListarRoutingModule { }
